export default __webpack_public_path__ + "static/media/resume.2b098c30.jpeg";